import "./App.scss";
import { useEffect, Fragment } from "react";
import { useSelector } from "react-redux";
//import webAudioTouchUnlock from "web-audio-touch-unlock";

import Welcome from "./components/Welcome";
import ThemeChooser from "./components/ThemeChooser";
import BingoGame from "./components/game/BingoGame";

import { gameActions } from "./store/game-slice";

function App() {

  useEffect(() => {
    // const context = new (window.AudioContext || window.webkitAudioContext)();
    // webAudioTouchUnlock(context).then(
    //   function (unlocked) {
    //     if (unlocked) {
    //       // AudioContext was unlocked from an explicit user action, sound should start playing now
    //     } else {
    //       // There was no need for unlocking, devices other than iOS
    //     }
    //   },
    //   function (reason) {
    //     console.error(reason);
    //   }
    // );
    // var source = context.createBufferSource();
    // source.connect(context.destination);
    // source.start();
  }, []);

  const currentScreen = useSelector((state) => state.game.activeScreen);
  const themes = useSelector((state) => state.game.themes);
  const activeTheme = useSelector((state) => state.game.activeTheme);

  return (
    <Fragment>
      <div className={`bingo-game-container ${activeTheme}`}>
        <div className="screen"></div>
        <div className="bingo-game-sub-container">
          {currentScreen === "welcome" && <Welcome />}
          {currentScreen === "choose_theme" && (
            <ThemeChooser buttonLabel="Let's Play!" startGame={true} />
          )}
          {currentScreen === "game" && <BingoGame />}
        </div>
      </div>
    </Fragment>
  );
}

export default App;
